// extracted by mini-css-extract-plugin
export default {"imageContainer":"imageLoader_imageContainer__ihs5K","loading":"imageLoader_loading__FawQq","skeleton":"imageLoader_skeleton__A4IFo"};